// extracted by mini-css-extract-plugin
export default {"headerBox":"HeaderBox_headerBox__FZwHe","headerBoxReuseable":"HeaderBox_headerBoxReuseable__gxOWl","backIcon":"HeaderBox_backIcon__zMDCB","headerText":"HeaderBox_headerText__NN4En"};